import React from 'react'

function Contact() {
  return (
    <div>contract</div>
  )
}

export default Contact;